import LeilaoMixin from '../../comunicator_wrapper/src/integrations/vue/mixins/leilao.mixin.js'


export default LeilaoMixin
